module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I would like to take this time to thank the many people who have been instrumental in getting this book completed and published: Jeff Saraceno of The History Press, the Boston Braves Historical Association for the player/fan reunions and keeping the memory of the Boston Braves alive and well, the librarians at the Boston Public Library and the staff of the photo archives for all their help, the staff of the Revere Public Library, the staff at the Baseball Hall of Fame Archives and Boston University Archives. I would also like to thank my wife, Charlene, for typing this manuscript and my beautiful daughter, Meadow Jean, for understanding that Daddy had to work rather than play with her.")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("1890 Boston Beaneaters. "), _c('i', [_vm._v("Courtesy of National Baseball Hall of Fame (NBHOF)")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 72
// module chunks = 0